import Repository from "./Repository";

const resource = "/bo/projects";

export default {
  get(params) {
    return Repository.get(`${resource}`, { params }).then(res => res.data);
  },

  getMedias(project_uuid) {
    const url = `projects/${project_uuid}/medias`;
    return Repository.get(url).then(res => res.data);
  },

  postMedia(project_uuid, payload) {
    const url = `projects/${project_uuid}/medias`;
    return Repository.post(url, payload).then(res => res.data);
  },

  destroyMedia(project_uuid, media__uuid) {
    const url = `projects/${project_uuid}/medias/${media__uuid}`;
    return Repository.delete(url).then(res => res.data);
  },

  fetchPlanningProjects(params) {
    return Repository.get(`${resource}/all`, { params }).then(res => res.data);
  },

  async getProjectLight(project_uuid) {
    return Repository.get(`${resource}/${project_uuid}/light`);
  },

  async getProject(project_uuid) {
    return Repository.get(`${resource}/${project_uuid}`);
  },

  async updateProject(project_uuid, payload) {
    return Repository.put(`${resource}/${project_uuid}`, payload);
  },

  async updateProjectLight(project_uuid, payload) {
    return Repository.put(`${resource}/${project_uuid}/light`, payload);
  },

  async getCalculation(project_uuid) {
    return Repository.get(`${resource}/${project_uuid}/calculation`);
  },

  async updateProjectPlanning(project_uuid, payload) {
    return Repository.put(`${resource}/${project_uuid}/planning`, payload);
  },

  /**
   * Editions
   */

  /**
   * Fetches in progress projects
   */
  fetchInProgressProjects({ dateFrom, dateTo } = {}) {
    if (!dateFrom || !dateTo) {
      return Repository.get(`${resource}/editions/in-progress`);
    }

    return Repository.get(
      `${resource}/editions/in-progress?date_start=${dateFrom}&date_end=${dateTo}`
    );
  },

  /**
   * Fetches accounting projects
   */
  fetchAccountingProjects(params) {
    return Repository.get("v2/editions/accounting", { params }).then(
      res => res.data
    );
  },

  /**
   * Fetches workshop projects by date_type
   */
  fetchWorkshopProjects({ dateType, dateFrom, dateTo } = {}) {
    if (!dateFrom || !dateTo || !dateType) return;

    return Repository.get(
      `${resource}/editions/workshop?export_type=${dateType}&date_start=${dateFrom}&date_end=${dateTo}`
    );
  },

  /**
   * Fetches workshop projects by date_type
   */
  fetchAdministrationProjects({ dateType, dateFrom, dateTo } = {}) {
    if (!dateFrom || !dateTo || !dateType) return;

    return Repository.get(
      `${resource}/editions/administration?export_type=${dateType}&date_start=${dateFrom}&date_end=${dateTo}`
    );
  },

  /**
   * Fetches tour book by date / applicators
   */
  fetchTourBookProjects(date, applicators = []) {
    if (!date) return;

    const applicatorsIds = applicators.join(",");

    return Repository.get(
      `${resource}/editions/tour-book?date=${date}&applicators=${applicatorsIds}`
    );
  },

  /**
   * Post a comment for tour book
   */
  postTourBookComment(payload) {
    return Repository.post(`${resource}/editions/tour-book`, payload);
  },

  /**
   * Medias
   */

  /**
   * Get a media by uuid
   */
  getMedia(project_uuid, media_uuid) {
    return Repository.get(`/projects/${project_uuid}/media/${media_uuid}`);
  },

  /**
   * Create a media
   */
  createMedia(project_uuid, media_uuid) {
    return Repository.post(`/projects/${project_uuid}/media/${media_uuid}`);
  },

  /**
   * Create media image
   */
  createMediaImage(projects_uuid, media_uuid, payload) {
    return Repository.post(
      `/projects/${projects_uuid}/media/${media_uuid}/image`,
      payload
    );
  },

  /**
   * Get a media image
   */
  getMediaImage(project_uuid, media_uuid) {
    return Repository.get(
      `/projects/${project_uuid}/media/${media_uuid}/image`
    );
  },

  /**
   * Delete a media
   */
  deleteMedia(project_uuid, media_uuid) {
    return Repository.delete(`/projects/${project_uuid}/media/${media_uuid}`);
  },

  /**
   * Articles
   */

  /**
   * Gets project articles by type. Default type: GENERAL
   *
   * @param {String} project_uuid Project UUID
   * @param {String} type Article type: GENERAL or MANAGEMENT.
   */
  getProjectArticles(project_uuid, type = "GENERAL") {
    return Repository.get(`${resource}/${project_uuid}/articles?type=${type}`);
  },

  /**
   * Add an article to project
   *
   * @param {String} project_uuid Project UUID
   * @param {Object} payload Article to add
   */
  addProjectArticle(project_uuid, payload) {
    return Repository.post(`${resource}/${project_uuid}/articles`, payload);
  },

  deleteProjectArticles(project_uuid, payload) {
    return Repository.delete(`${resource}/${project_uuid}/articles`, {
      data: payload
    });
  },

  updateProjectArticle(project_uuid, payload) {
    return Repository.put(`${resource}/${project_uuid}/articles`, payload);
  }
};
